import { Controller } from "stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  static values = { url: String };

  connect() {
    document.addEventListener(
      "promote:program-translation-status-changed",
      this._refresh
    );
  }

  disconnect() {
    document.removeEventListener(
      "promote:program-translation-status-changed",
      this._refresh
    );
  }

  _refresh = () => {
    Rails.ajax({
      url: this.urlValue,
      type: "GET",
      dataType: "script",
    });
  };
}
